import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Tab, Nav, Modal, Button, Spinner, Form, Card as BoxCard } from "react-bootstrap";
import { Profile, TableDocument, DocumentText, Camera, Coin, Card, Information} from "iconsax-react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FormIDS from "../../../../components/Struttura/LaMiaStruttura/formIDS";
import FormSport from "../../../../components/Struttura/LaMiaStruttura/formSport";
import FormTitoli from "../../../../components/Struttura/LaMiaStruttura/formTitoli";
import FormFoto from "../../../../components/Struttura/LaMiaStruttura/formFoto";
import FormFitCoin from "../../../../components/Struttura/LaMiaStruttura/formFitcoin";
import FormFatturazione from "../../../../components/Struttura/LaMiaStruttura/formFatturazione";
import VideoPresentazione from "../../../../components/Struttura/SchedaApp/VideoPresentazione";
import MyApiClient from "../../../../../api-client/MyApiClient";
import { usePageTitle, useStatoInSolaLettura, statoProfilo } from "../../../../layouts/PageHeaderExtra";

export const StrutturaEdit = () => {

	const { id } = useParams();
	const navigate = useNavigate();
	// «Elimina struttura»: era nel menu a fine riga della lista, ora sta nella scheda (03/10/2026).
	const [confermaElimina, setConfermaElimina] = useState(false);

	const [profile, setProfile] = useState(null);
	// Titolo della pagina = nome della struttura (regola SUI, docs/sportid-ui.md capitolo 6)
	usePageTitle(profile?.name || profile?.club?.name);
	// Stato del profilo in sola lettura accanto al titolo (manca l'API per cambiarlo)
	const statoProf = statoProfilo(profile?.club?.profileStatus || profile?.profileStatus);
	useStatoInSolaLettura(statoProf.label, statoProf.tono);
	const [reloadKey, setReloadKey] = useState(0);
	const [loadingShowed, setLoadingShowed] = useState(false);

	const tabData = [
		{
			id: 'ids',
			name: "IDS",
			icon: <Profile size='18' variant='Bulk' />,
			content: <FormIDS profile={profile} isDisabled={true}/>,
		},
		{
			id: 'sport',
			name: "Sport",
			icon: <TableDocument size='18' />,
			content: <FormSport profile={profile} isDisabled={true} />,
		},
		{
			id: 'titoli',
			name: "Titoli",
			icon: <DocumentText size='18' />,
			content: <FormTitoli profile={profile} isDisabled={true} />,
		},
		{
			id: 'copertina',
			name: "Foto",
			icon: <Camera size='18' />,
			content: <FormFoto profile={profile} isDisabled={true} />,
		},
		{
			// Il super admin carica il video di presentazione gia` approvato (sez. E degli interventi per l'app)
			id: 'video',
			name: "Video di presentazione",
			icon: <Camera size='18' />,
			content: <BoxCard><BoxCard.Body className="sid-card-body--spaced"><VideoPresentazione clubId={id} superAdmin /></BoxCard.Body></BoxCard>,
		},
		{
			id: 'fitcoins',
			name: "FitCoins",
			icon: <Coin size='18' />,
			content: <FormFitCoin profile={profile} isDisabled={true} />,	
		},
        {
			id: 'fatturazione',
			name: "Documenti fiscali",
			icon: (
				<>
					<Card size='18' />
					{profile && profile.club && profile.club.invoiceDataSender && profile.club.invoiceDataSender.status === 'WAIT_RESPONSE' && (
						<Information variant="Bulk" size='24' color='#ff6b6b' />
					)}
				</>
			),
			content: <FormFatturazione profile={profile} isSuperAdmin={true} userId={id} />,	
		},
	];

	const location = useLocation();
    const [defaultTab, setDefaultTab] = useState(() => {
		const initialQuery = new URLSearchParams(location.search);
		return initialQuery.get('tab') || tabData[0].name.toLowerCase();
	});
	
	useEffect(() => {
		const query = new URLSearchParams(location.search);
		const tab = query.get('tab');
		if (tab && tab !== defaultTab) {
			setDefaultTab(tab);
		}
	}, [location.search, defaultTab]);

	const MAX_FILE_SIZE = 5 * 1024 * 1024;
	const ALLOWED_FILE_TYPES = ['image/png', 'image/jpeg'];

	const [newTitleFile, setNewTitleFile] = useState(null);
	const [modalCentered, setModalCentered] = useState(false);
  	
	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

	const handleFileChange = (event) => {
		setNewTitleFile(event.target.files[0]);
	};

	const addTitle = (e) => {
        e.preventDefault();

		setModalCentered(false);

		let file = newTitleFile;

		if (file) {

			if (file.size > MAX_FILE_SIZE) {
				setModalTitle("Errore durante l'operazione");
				setModalText('Il file selezionato supera la dimensione massima consentita.');
				setModalShowed(true);
				return;
			}

			if (!ALLOWED_FILE_TYPES.includes(file.type)) {
				setModalTitle("Errore durante l'operazione");
				setModalText('Il file selezionato non è di tipo consentito.');
				setModalShowed(true);
				return;
			}

			const reader = new FileReader();
			reader.onloadend = () => {
				const base64String = reader.result.split(',')[1];
				// console.log(base64String);
				updateProfile(base64String);
			};
			reader.readAsDataURL(file);
		}
    };

	function updateProfile(base64String) {

		const saveData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    let profile_send = JSON.parse(JSON.stringify(profile));
					profile_send.club.logo = base64String;
                    delete profile_send.club.pictures;

					setLoadingShowed(true);
                    const saveResult = await apiClient.updateProfile(token, profile_send);
					setLoadingShowed(false);

                    if(saveResult && saveResult.error) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText("Si è verificato un errore durante il salvataggio ("+saveResult.error+")");
                        setModalShowed(true);
                    } else {
						setNewTitleFile(null);
						setReloadKey(k => k + 1);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        saveData();
	}

	const eliminaStruttura = async () => {
		setConfermaElimina(false);
		const tokenDetailsString = sessionStorage.getItem('userDetails');
		if (!tokenDetailsString) return;
		const token = JSON.parse(tokenDetailsString).idToken;
		setLoadingShowed(true);
		const deleteResult = await new MyApiClient().deleteProfile(token, id);
		setLoadingShowed(false);
		if (deleteResult) {
			setModalTitle("Errore durante l'operazione");
			setModalText(deleteResult);
			setModalShowed(true);
		} else {
			navigate('/superadmin/anagrafiche/strutture-sportive');
		}
	};

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const profileData = await apiClient.getProfiles(token,id);
					setLoadingShowed(false);
					
                    setProfile(profileData);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [id, reloadKey]);

	return (
		<>
			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalCentered} centered>
                <Modal.Header>
                    <Modal.Title>Seleziona il logo</Modal.Title>
                    <Button
                        onClick={() => setModalCentered(false)}
                        variant=""
                        className="btn-close"
                    >
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col className="col-lg-12 pb-4">
                                <Form.Label>Seleziona file</Form.Label>
                                <Form.Control type="file" placeholder="Carica il file" onChange={handleFileChange} />
                            </Col>
                        </Row>
						<Row>
                            <Col className="col-lg-12 pb-4">
                                <i>Dimensioni consigliate: 400px di larghezza e 225px di altezza</i>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setModalCentered(false)}>
                        Annulla
                    </Button>
                    <Button onClick={addTitle} className="btn btn-primary btn-add">Salva</Button>
                </Modal.Footer>
            </Modal>
			
			<div className="custom-tab-1">
				<Tab.Container defaultActiveKey={defaultTab}>
					<Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
						{tabData.map((data, i) => (
							<Nav.Item as="li" key={i} className="tabMenu">
								<Nav.Link eventKey={data.id.toLowerCase()}>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>
					<Row className="align-items-start mt-4">
						<div className="col-xl-12">
							<Tab.Content>
								{tabData.map((data, i) => (
									<Tab.Pane eventKey={data.id.toLowerCase()} key={i}>
										{data.content}
									</Tab.Pane>
								))}
							</Tab.Content>
						</div>
					</Row>
				</Tab.Container>
			</div>

			{/* Azioni della struttura: in fondo alla scheda, l'eliminazione a sinistra. */}
			<div className="d-flex justify-content-between mt-4">
				<Button variant="danger" onClick={() => setConfermaElimina(true)}>Elimina struttura</Button>
				<span />
			</div>

			<Modal className="fade" show={confermaElimina} onHide={() => setConfermaElimina(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Eliminare la struttura?</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					Eliminare la struttura «{profile?.name || profile?.club?.name || 'senza nome'}»? L'operazione non si può annullare.
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-light btn-add" onClick={() => setConfermaElimina(false)}>Annulla</Button>
					<Button variant="danger" onClick={eliminaStruttura}>Elimina</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}
export default StrutturaEdit;